import {
  Breadcrumbs as SpectrumBreadcrumbs,
  Divider,
  Item,
} from '@adobe/react-spectrum';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

export type Breadcrumb = {
  name: ReactNode;
  path?: string;
  key: string;
};

interface BreadcrumbListProps {
  breadcrumbList: Breadcrumb[];
}

export const Breadcrumbs = (props: BreadcrumbListProps) => {
  const { breadcrumbList } = props;
  const navigate = useNavigate();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onBreadcrumbAction = (key: any) => {
    const selectedBreadcrumb = breadcrumbList.find(
      (breadcrumb) => breadcrumb.key === key
    );
    if (selectedBreadcrumb?.path) {
      navigate(selectedBreadcrumb.path);
    }
  };

  return (
    <div>
      <SpectrumBreadcrumbs size="L" onAction={onBreadcrumbAction}>
        {breadcrumbList.map((f) => (
          <Item key={f.key}>{f.name}</Item>
        ))}
      </SpectrumBreadcrumbs>
      <Divider size="M" />
    </div>
  );
};
